import React from 'react';
import { useGetDriveUsersQuery } from '../operation.generated';
import { WorkspaceMember } from '../types';
import { useUserTeam } from '../../../context/user/UserContext';
import { mapTeamMemberToWorkspaceMember } from '../utils';

const useWorkspaceMembers = ({
  userId,
  driveId,
}: {
  userId: string;
  driveId: string;
}) => {
  const userTeam = useUserTeam();
  const { data: driveUserData, loading } = useGetDriveUsersQuery({
    skip: !driveId,
    variables: {
      inputs: {
        driveId,
      },
    },
  });
  /**
   * Take the existing drive users with access and use team data
   * to populate the workspace member data model
   */
  const workspaceMembers: WorkspaceMember[] = React.useMemo(() => {
    if (!driveUserData?.driveUsers) return [];
    const results = [...driveUserData.driveUsers];
    /**
     * Ensure that the user (self) is at the top of the members access list
     */
    results.sort((a, b) => {
      if (a.id === userId) return -1;
      if (b.id === userId) return 1;
      return 0;
    });
    return results.reduce<WorkspaceMember[]>((acc, driveUser) => {
      const teamMember = userTeam?.members.find(
        member => member.id === driveUser.id
      );
      if (!teamMember) return acc;
      return acc.concat(
        mapTeamMemberToWorkspaceMember({
          userId: userId || '',
          teamMemberId: driveUser.id,
          teamMember,
          driveRole: driveUser.role,
        })
      );
    }, []);
  }, [driveUserData?.driveUsers, userId, userTeam?.members]);
  return {
    workspaceMembers,
    loading,
  };
};

export default useWorkspaceMembers;
